<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-row>
          <v-col cols="9" md="11"
            ><v-card-title
              >Cash Record<span>({{ dateString }})</span></v-card-title
            ></v-col
          >
          <v-col cols="3" md="1">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mt-3" icon>
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <v-date-picker v-model="date" range scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(date), getAllCashRecord()"
                >
                  {{ $t("salesSummaryPage.choose") }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="5" md="3" class="ml-4">
            <v-select
              class="mt-3"
              v-model="selectBranch"
              :items="branchList"
              item-text="name"
              item-value="branch_id"
              @change="getAllCashRecord()"
              outlined
              dense
            ></v-select
          ></v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <base-card>
              <div class="d-flex align-center justify-space-between pr-3">
                <v-spacer></v-spacer>
                <div v-if="cashRecordList.length != 0">
                  <export-excel
                    :data="cashRecordList"
                    :fields="json_fields"
                    :name="filename"
                  >
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"> mdi-download </v-icon>
                      </template>
                      <span>Download Cash Record Report </span>
                    </v-tooltip>
                  </export-excel>
                </div>
              </div>
              <v-card-text>
                <v-data-table
                  :loading="listLoading"
                  :headers="headers"
                  :items="cashRecordList"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  item-key="cash_record_key"
                  
                  :no-data-text="$t('dailyModifierSalesPage.noData')"
                >
                  <template v-slot:item.type="{ item }">
                    <span v-if="item.type == '0'">Opening Balance</span>
                    <span v-else-if="item.type == '1'">Cash In</span>
                    <span v-else-if="item.type == '2'">Cash Out</span>
                    <span v-else-if="item.type == '3'">Payment</span>
                    <span v-else-if="item.type == '4'">Refund</span>
                  </template>
                </v-data-table>
                <!-- <div class="text-center py-2">
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                  ></v-pagination>
                </div> -->
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </base-card>
    </v-col>
  </v-row>
</template>
          <script>
import { BASEURL } from "@/api/baseurl";
import axios from "axios";

import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "Cash-Record",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Cash Record",
  },
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      json_fields: {
        Branch: "branchName",
        By: "userName",
        Type: {
          field: "type",
          callback: (value) => {
            if (value == "0") {
              return "Opening Balance";
            } else if (value == "1") {
              return "Cash In";
            } else if (value == "2") {
              return "Cash Out";
            } else if (value == "3") {
              return "Payment";
            } else if (value == "4") {
              return "Refund";
            }
          },
        },
        Amount: "amount",
        "Payment Method": "paymentName",
        "Reason": "remark",
        "Created At": "created_at",
      },
      domain: BASEURL,
      company_id: "",
      date: [],
      modal: false,
      branchList: [],
      cashRecordList: [],
      selectBranch: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      listLoading: false,
    };
  },
  computed: {
    filename() {
      var moment = require("moment");
      return (
        "Cash_Record_Report_" +
        (this.date.length > 1
          ? this.date[0] != this.date[1]
            ? moment(this.date[1]).isBefore(this.date[0])
              ? this.date[1] + " until " + this.date[0]
              : this.date[0] + " until " + this.date[1]
            : this.date[0]
          : this.date[0]) +
        ".xls"
      );
    },

    dateString() {
      var moment = require("moment");
      return this.date.length > 1
        ? this.date[0] != this.date[1]
          ? moment(this.date[1]).isBefore(this.date[0])
            ? this.date[1] + "~" + this.date[0]
            : this.date[0] + "~" + this.date[1]
          : this.date[0]
        : this.date[0];
    },

    headers() {
      return [
        {
          text: "Branch",
          align: "start",
          sortable: false,
          value: "branchName",
        },

        {
          text: "By",
          align: "start",
          sortable: false,
          value: "userName",
        },

        {
          text: "Type",
          align: "start",
          sortable: false,
          value: "type",
        },

        {
          text: "Amount",
          align: "start",
          value: "amount",
          sortable: true,
        },

        {
          text: "Payment Method",
          align: "start",
          value: "paymentName",
          sortable: false,
        },

        {
          text: "Reason",
          align: "start",
          value: "remark",
          sortable: false,
        },

        {
          text: "Created At",
          align: "start",
          value: "created_at",
          sortable: true,
        },
      ];
    },
  },
  watch: {
    date() {
      this.cashRecordList = [];
    },
    selectBranch() {
      this.cashRecordList = [];
    },
  },
  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyBranch();
  },
  methods: {
    getAllCashRecord() {
      this.listLoading = true;
      if (this.date.length <= 1) {
        const params = new URLSearchParams();
        params.append("getCashRecordList", "done");
        params.append("branch_id", this.selectBranch);
        params.append("month", this.date[0]);

        axios({
          method: "post",
          url: this.domain + "/report/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.cashRecordList = response.data.report;
              this.listLoading = false;
            } else {
              this.cashRecordList = [];
              this.listLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        if (this.date[0] == this.date[1]) {
          const params = new URLSearchParams();
          params.append("getCashRecordList", "done");
          params.append("branch_id", this.selectBranch);
          params.append("month", this.date[0]);

          axios({
            method: "post",
            url: this.domain + "/report/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);

              if (response.data.status == "1") {
                this.cashRecordList = response.data.report;
                this.listLoading = false;
              } else {
                this.cashRecordList = [];
                this.listLoading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          var moment = require("moment");
          var firstDate = "";
          var secondDate = "";
          if (moment(this.date[1]).isBefore(this.date[0])) {
            firstDate = this.date[1];
            secondDate = this.date[0];
          } else {
            firstDate = this.date[0];
            secondDate = this.date[1];
          }

          const params = new URLSearchParams();
          params.append("getCashRecordRangeList", "done");
          params.append("branch_id", this.selectBranch);
          params.append("first_date", firstDate);
          params.append("second_date", secondDate);

          axios({
            method: "post",
            url: this.domain + "/report/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);

              if (response.data.status == "1") {
                this.cashRecordList = response.data.report;
                this.listLoading = false;
              } else {
                this.cashRecordList = [];
                this.listLoading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);
      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var moment = require("moment");
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;
            this.date.push(moment().format("YYYY-MM-DD"));
            this.getAllCashRecord();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
     
          
          
          